import ReactAppboy from 'utils/appboy';
import logger from 'utils/logger';

export const setBrazeUserAttributes = (brazeAttributes: Record<string, string>) => {
  const {
    setFirstName,
    setLastName,
    setHomeCity,
    setPhoneNumber,
    setCustomUserAttribute,
  } = ReactAppboy;
  for (const key in brazeAttributes) {
    const value = brazeAttributes[key];
    try {
      switch (key) {
        case '$FirstName':
          return setFirstName(value);
        case '$LastName':
          return setLastName(value);
        case '$City':
          return setHomeCity(value);
        case '$Mobile':
        case 'phoneNumber':
          return setPhoneNumber(value);
        default:
          return setCustomUserAttribute(key, value);
      }
    } catch (error) {
      logger.warn({ error, message: 'Error setting Braze User Attributes' });
    }
  }
};
